import React, { useState } from 'react'

function Card(props) {
	const [count, setCount] = useState(props.count? props.count: 1)
	const [cardId, setCardId] = useState(props.id)
	const dragStart = e => {
		const target = e.target;
		const parent = e.target.parentNode
		e.dataTransfer.setData("card-id", JSON.stringify({tid: target.id, pid: parent.id}));
	}
	const dragOver = e => {
		e.stopPropagation();
	}
	return(<div id={props.id} className="card" draggable={props.draggable} onDragStart={dragStart} onDragOver={dragOver}
		style={{'justify-content': props.withCount? 'space-between': 'center'}}>
		{props.withCount && <div></div>}
		{props.children}
		{props.withCount && <input type="number" value={count}
			onChange={(e) => {
				setCount(e.target.value)
				props.onChange(cardId, e.target.value)
			}}
			max={props.maxDays}
			min='1'
		/>}
	</div>);
}

export default Card;
